import { nextCargoApi } from "../../baseApi";
import { ListLogDriver } from "./logDriver.types";

export const logDriverApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    listLogDriver: build.infiniteQuery<ListLogDriver["result"], ListLogDriver["args"], ListLogDriver["pageParam"]>({
      infiniteQueryOptions: {
        initialPageParam: { page: 0, pageSize: 50, sortDirection: "asc", sortField: "createdAt" },
        getNextPageParam: (lastPage, _, lastPageParam) => {
          const nextPage = lastPageParam.page + 1;
          const remainingPages = lastPage?.total - nextPage;

          if (remainingPages <= 0) {
            return undefined;
          }

          return {
            ...lastPageParam,
            page: nextPage
          };
        },
        getPreviousPageParam: (_, __, firstPageParam) => {
          const prevPage = firstPageParam.page - 1;
          if (prevPage < 0) return undefined;

          return {
            ...firstPageParam,
            page: prevPage
          };
        }
      },
      query: ({ queryArg: { id, ...params }, pageParam }) => ({
        url: `/log-driver/${id}`,
        params: Object.assign({}, pageParam, params)
      })
    })
  })
});

logDriverApi.enhanceEndpoints({
  endpoints: {
    listLogDriver: {
      providesTags: (result) => {
        return result ? [...result.pages.flatMap(({ data }) => data.map(({ id }) => ({ type: "DriverLogs" as const, id })))] : [{ type: "DriverLogs", id: "LIST" }];
      }
    }
  }
});
